const solidDark = '#2A0944';
const solidLight = '#C68B59';
const darkText = '#A5C9CA';
const lightText = '#FCF8E8';
const darkBackground = '#726A95';
const lightBackground = '#FCF8E8';

export {
    solidDark, 
    solidLight, 
    darkText, 
    lightText,
    darkBackground,
    lightBackground,
};